export enum PageStatusEnum {
  PRIVATE = 0,
  PROCESSING = 2,
  PUBLIC = 3,
  FAILED = 4,
}
